import React from 'react';
import InfoCard from '../InfoCard/InfoCard';
import { connect } from 'react-redux';
import './CardSection.css';
import Posts from '../db.json'

class CardSection extends React.Component {
  
  renderCards = () => {
    let posts = [];
    Posts.posts.map(post => {
      posts.push(
        <InfoCard 
          tags = {post.tags}
          key = {post.link}
          category = {post.category}
          headline = {post.headline}
          bodytext = {post.bodytext}
          link = {post.link} />
      )
    })
    return posts
  }

  renderFilteredCards = () => {
    let filteredPosts = [];
    let { input } = this.props.input;
    input = input.toLowerCase()
    Posts.posts.filter((post, index) => {
      if (post.tags.includes(input) || 
        post.headline.toLowerCase().includes(input) || 
        post.bodytext.toLowerCase().includes(input) || 
        post.category.toLowerCase().includes(input)) {
          filteredPosts.push(
            <InfoCard 
              tags = {post.tags}
              key = {index}
              category = {post.category}
              headline = {post.headline}
              bodytext = {post.bodytext}
              link = {post.link} />
          )
      }
    })
    return filteredPosts;
  }
  
  render() {
    return (
      <div id="section">
      { this.props.input.input.length === 0
        ? this.renderCards()
        : this.renderFilteredCards() }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  input: state.input
});

export default connect(mapStateToProps)(CardSection);